import AdminAccountPage from './AdminAccountPage';

export default AdminAccountPage;
